export default __webpack_public_path__ + "static/media/Alain Pinel Realtors.8acbc60a.jpg";